import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const EditIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="23" viewBox="0 0 19 23">
    <g fill="currentColor">
      <path d="M18.0213 4.58685L16.3165 2.92356C16.1637 2.7738 15.9737 2.66751 15.7686 2.61593C15.3477 2.5101 14.8988 2.63918 14.5969 2.95292L3.11911 14.8706L1.61623 16.4318L3.76582 18.531L5.06389 19.798L6.56743 18.237L18.0446 6.31909C18.5122 5.83362 18.5017 5.05592 18.0213 4.58685Z" />
      <path d="M0.122247 20.8534C0.119547 20.8641 0.116181 20.8747 0.11348 20.8854C0.0824073 21.0146 0.106312 21.1477 0.178289 21.2557C0.196367 21.2824 0.217447 21.3084 0.241369 21.3315C0.30001 21.3884 0.372534 21.4294 0.451789 21.4494C0.525717 21.4679 0.602869 21.4681 0.676249 21.4494C0.691257 21.4461 0.705768 21.4419 0.719782 21.4368L1.01907 21.3308L0.218533 20.5493L0.122079 20.854L0.122247 20.8534Z" />
      <path d="M1.3481 16.9703L0.411813 19.9365L1.6205 21.1168L4.53528 20.0826L4.04639 19.605L1.3481 16.9703Z" />
    </g>
  </svg>,
  'edit'
);
